const Btn = ({ className, Svg, cta, onClick }) => {
    return (
        <button
            className={`Btn ${className}`}
            onClick={onClick}
        >
            {Svg && <Svg />}
            <b>{cta}</b>
        </button>
    );
};

export default Btn;
